<template>
  <div style="height:100%;">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span style="color:#4A90E2">
            <i class="el-icon-location"></i>首页
          </span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>地图</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="block"
           style="margin-top:12px;">
        <el-date-picker @change="change"
                        v-model="daterange"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>

    <div id="container"
         style="width:100%;height:90%;"></div>
  </div>
</template>

<script>
import { getToken } from '../utils/auth'
import { equiphistory, equipinfo } from '../service/getData'
import moment from 'moment'
var map = null
var infoWindow = null
var markers = []
// 地图覆盖点
// var overlayGroups = null
// 折线
var polyline = null
function markerClick(e) {
  infoWindow.setContent(e.target.content)
  infoWindow.open(map, e.target.getPosition())
}
export default {
  name: 'app',
  data() {
    return {
      tp: null,
      deviceList: null,
      listPointAll: null,
      listPoint: null,
      // 时间范围
      daterange: [
        moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD'),
        moment().format('YYYY-MM-DD')
      ],
      // 开始时间
      dbt:
        null ||
        moment()
          .subtract(1, 'year')
          .format('YYYY-MM-DD'),
      // 结束时间
      edt: null || moment().format('YYYY-MM-DD'),
      // 路由来的params/设备ID
      equipid: this.$route.params.mapId
    }
  },
  methods: {
    // 查询时间改变后，更新地图点
    async change(v) {
      if (infoWindow) {
        infoWindow.close()
      }
      // 删除地图原来的点
      if (map !== null) {
        map.remove(polyline)
        markers.map(item => {
          map.remove(item)
        })
        markers = []
        // map.remove(overlayGroups)
      }
      if (v != null && v.length != 0) {
        this.dbt = v[0]
        this.edt = v[1]
      }

      let dbt = this.dbt
      let edt = this.edt
      let equipid = this.equipid

      let result = await equiphistory(dbt, edt, equipid)

      // 设备列表
      this.deviceList = result.data.total ? JSON.parse(result.data.data) : []
      // 经纬度数组[jd,wd]
      let tempList = []
      let lineArr = []
      this.deviceList.map(item => {
        let arr = []
        arr.push(item.jd)
        arr.push(item.wd)
        lineArr.push(new AMap.LngLat(item.jd, item.wd))
        tempList.push(arr)
      })
      // 这里两个点的数据忘了要干什么用。
      this.listPoint = tempList
      this.listPointAll = tempList

      if (this.listPoint || this.listPoint.length === 0) {
        // return false
      }
      // 设置开始的中心点
      map.setCenter(new AMap.LngLat(this.listPoint[0][0], this.listPoint[0][1]))

      // 在地图上加 点
      this.listPoint.map((index, i) => {
        // 初始化 markers
        this.addMarker(index, i)
      })
      // overlayGroups = new AMap.OverlayGroup(markers)
      // map.add(overlayGroups)
      map.add(markers)

      // 创建折线实例
      polyline = new AMap.Polyline({
        path: lineArr,
        borderWeight: 1, // 线条宽度，默认为 1
        strokeColor: 'white', // 线条颜色
        lineJoin: 'round' // 折线拐点连接处样式
      })
      // 将折线添加至地图实例
      map.add(polyline)

      map.setFitView()
    },

    addMarker(point, i) {
      let marker = new AMap.Marker({
        icon: '/static/point.png',
        position: point,
        offset: new AMap.Pixel(0, 0)
      })
      let equipname = this.$route.params.mapName
      let contentHTML = `<div>设备名称：${equipname}</div><div>经纬度 ${
        this.deviceList[i]['jd']
      },${this.deviceList[i]['wd']}</div>`
      this.tp.map((n, index) => {
        let no = index + 1
        contentHTML += `<div>${n.tnm}：${this.deviceList[i]['col' + no]}</div>`
      })

      contentHTML = contentHTML + `<div>时间：${this.deviceList[i]['dt']}</div>`
      marker.content = contentHTML
      marker.on('click', markerClick)
      marker.emit('click', {
        target: marker
      })
      markers.push(marker)
      // marker.setMap(map)
    },
    async equiphistory() {
      this.equipid = this.$route.params.mapId
      // 获取类型 ？有什么用？
      let tp = await equipinfo(this.equipid)
      this.tp = tp.data.tp

      let result = await equiphistory(this.dbt, this.edt, this.equipid)

      this.deviceList = result.data.total ? JSON.parse(result.data.data) : []
      if (this.deviceList || this.deviceList.length === 0) {
        infoWindow.close()
      }
      let tempList = [] //
      let lineArr = []
      this.deviceList.map(item => {
        let arr = []
        arr.push(item.jd)
        arr.push(item.wd)
        lineArr.push(new AMap.LngLat(item.jd, item.wd))
        tempList.push(arr)
      })

      this.listPoint = tempList
      this.listPointAll = tempList

      map = new AMap.Map('container', {
        layers: [new AMap.TileLayer.Satellite()],
        zooms: [1, 10],
        resizeEnable: true,
        expandZoomRange: true
        // center: this.listPoint[0]
      })
      markers.map(item => {
        map.remove(item)
      })
      // 创建折线实例
      polyline = new AMap.Polyline({
        path: lineArr,
        borderWeight: 1, // 线条宽度，默认为 1
        strokeColor: 'white', // 线条颜色
        lineJoin: 'round' // 折线拐点连接处样式
      })
      // 将折线添加至地图实例
      map.add(polyline)
      if (this.listPoint && this.listPoint.length) {
        map.setCenter(this.listPoint[0])
      }

      this.listPoint.map((index, i) => {
        this.addMarker(index, i)
      })

      // overlayGroups = new AMap.OverlayGroup(markers)
      // map.add(overlayGroups)
      map.add(markers)
      map.setFitView()
    }
  },
  watch: {
    $route: async function() {
      infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, 0)
      })
      // console.warn('路由改变了：：',this.$route)
      await this.equiphistory()
    }
  },
  mounted() {
    if (!getToken()) {
      this.$router.push('/login')
      return
    }
    infoWindow = new AMap.InfoWindow({
      offset: new AMap.Pixel(0, 0)
    })
    this.equiphistory()
  }
}
</script>
<style lang="scss" scoped>
#map {
  background: white;
  height: 90%;
}
</style>
<style>
.amap-marker-label {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
  background: #3e95fa;
  color: white;
}
</style>
